import React from 'react'
import styles from './Footer.module.css'
import { NavHashLink  } from 'react-router-hash-link';
import { Button, IconButton } from "@material-ui/core";
import logo from '../../assets/logo.png'
import Tooltip from '@material-ui/core/Tooltip';


function Footer() {
    return (
        <div className={styles.component}>
            <div className={styles.navButtonCover}>
                <NavHashLink smooth  to='/#top' className={styles.hashLink}>
                    <Button
                    variant="contained"
                    size="small"
                    className={styles.navButtons}
                    >
                        All Resources
                    </Button>    
                </NavHashLink>
                <NavHashLink smooth  to='/#covid19-guides' className={styles.hashLink}>
                    <Button
                    variant="contained"
                    size="small"
                    className={styles.navButtons}
                    >
                        Covid-19 Guides 
                    </Button>    
                </NavHashLink>
                <NavHashLink smooth  to='/#important-links' className={styles.hashLink}>
                    <Button
                    variant="contained"
                    size="small"
                    className={styles.navButtons}
                    >
                        Important Links 
                    </Button>    
                </NavHashLink>
                <a href="https://www.covid19india.org/" style={{textDecoration:"none"}}>
                    <Button
                    variant="contained"
                    size="small"
                    className={styles.navButtons}
                    >
                        Covid-19 Stats
                    </Button> 
                </a>
                <NavHashLink smooth  to='/login' className={styles.hashLink}>
                    <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={styles.navButtons}
                    >
                        Login
                    </Button>    
                </NavHashLink>
            </div><br/>
            <div className={styles.navButtonCover}>
                <div className="name">
                    <img src={logo} alt="logo" className={styles.bottomLogo}/><br/>
                    <h3 style={{color:"#fff",letterSpacing:'1px'}}>An unofficial student orgnization and <span style={{color:'#000'}}>#1</span> largest digital media in VIT Vellore.</h3>
                </div>
            </div>
            <div className={styles.rightFootCover}>

                <h2 style={{color:"#fff",letterSpacing:'1px'}}>Contact Us</h2>

                <div className={styles.iconsOuterCover}>
            <div className={styles.iconsFooter}>
                <a href="https://in.linkedin.com/company/vitrendz" style={{textDecoration:"none"}} target="_blank" rel="noreferrer">
                    <Tooltip title="LinkedIn">
                        <IconButton className={styles.shareButton}>
                            <i className="fab fa-linkedin-in"></i>
                        </IconButton>
                    </Tooltip>
                    </a>

                    <a href="https://www.instagram.com/vitrendz/?hl=en" style={{textDecoration:"none"}} target="_blank" rel="noreferrer">
                    <Tooltip title="Instagram">
                        <IconButton className={styles.shareButton}>
                            <i className="fab fa-instagram"></i>
                        </IconButton>
                    </Tooltip>
                    </a>

                    <a href="https://www.facebook.com/pages/category/Social-Club/VITrendz-110405110659537/" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
                    <Tooltip title="Facebook">
                        <IconButton className={styles.shareButton}>
                            <i className="fab fa-facebook"></i>
                        </IconButton>
                    </Tooltip>
                    </a>

                    <a href="mailto:vitrendzdocumentation2020@gmail.com" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
                    <Tooltip title="Gmail">
                        <IconButton className={styles.shareButton}>
                            <i className="fas fa-envelope"></i>
                        </IconButton>
                    </Tooltip>
                    </a>

                    
                    </div><br/>

                    Website: <a href="https://www.vitrendz.tech" target="_blank" rel="noreferrer">www.vitrendz.tech</a>
                    </div>
                
            </div>
        </div>
    )
}

export default Footer
